var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 17C8 16.4477 8.44772 16 9 16H21C21.5523 16 22 16.4477 22 17C22 17.5523 21.5523 18 21 18H9C8.44772 18 8 17.5523 8 17Z",
    className: "Icon-fill-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12C8 11.4477 8.44772 11 9 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H9C8.44772 13 8 12.5523 8 12Z",
    className: "Icon-fill-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7C8 6.44772 8.44772 6 9 6H21C21.5523 6 22 6.44772 22 7C22 7.55228 21.5523 8 21 8H9C8.44772 8 8 7.55228 8 7Z",
    className: "Icon-fill-color"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7C2 6.44772 2.44772 6 3 6H5C5.55228 6 6 6.44772 6 7C6 7.55228 5.55228 8 5 8H3C2.44772 8 2 7.55228 2 7Z",
    className: "Icon-fill-color"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 11.4477 2.44772 11 3 11H5C5.55228 11 6 11.4477 6 12C6 12.5523 5.55228 13 5 13H3C2.44772 13 2 12.5523 2 12Z",
    className: "Icon-fill-color"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 17C2 16.4477 2.44772 16 3 16H5C5.55228 16 6 16.4477 6 17C6 17.5523 5.55228 18 5 18H3C2.44772 18 2 17.5523 2 17Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListX2);
export default __webpack_public_path__ + "static/media/ListX2.cff1f044814d03d728b65a57b4beaf46.svg";
export { ForwardRef as ReactComponent };